import React from 'react';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AreaTitle from './AreaTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ImageWithCredit from './ImageWithCredit';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  modal: {
    overflow: 'scroll',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6, 0),
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  titleContainer: {
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
    position: 'relative',
    marginBottom: theme.spacing(1),
  },
  topCloseButton: {
    position: 'absolute',
    right: -12,
    top: -48,
    [theme.breakpoints.up('sm')]: {
      top: -8,
    },
  },
  body: {
    width: '80%',
  },
  content: {
    backgroundColor: 'white',
    padding: theme.spacing(2),
  },
  firstImageContainer: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
  imageTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  closeButtonContainer: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  bottomCloseButton: {
    color: 'white',
  },
}));

const ImagesModal = ({ open, handleClose, images = [], number, area }) => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  return (
    <Modal
      open={open}
      onClose={handleClose}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      className={classes.modal}
    >
      <div className={classes.body}>
        <div className={classes.titleContainer}>
          <AreaTitle number={number} area={area} />
          <IconButton
            onClick={handleClose}
            color="inherit"
            className={classes.topCloseButton}
          >
            <CloseIcon fontSize={match ? 'large' : 'default'} />
          </IconButton>
        </div>
        <Grid container className={classes.content}>
          <Grid
            item
            xs={12}
            sm={6}
            container
            className={classes.firstImageContainer}
          >
            <Grid item xs={12}>
              <ImageWithCredit {...images[0]} />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.imageTitle}>
                {images[0]?.title}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} container>
            <Grid item xs={12}>
              <ImageWithCredit {...images[1]} isCreditShown={!match} />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.imageTitle}>
                {images[1]?.title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.closeButtonContainer}>
          <Button
            variant="text"
            startIcon={<CloseIcon />}
            className={classes.bottomCloseButton}
            onClick={handleClose}
          >
            閉じる
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ImagesModal;
